export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t-4 border-orange-500">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Column 1 - Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/2626c5dd14f7e79bab7b94489c13c72e/3f647aacc53a85cf6a7976138ca68ef4.png" 
              alt="Doolittle Air - Heating & Cooling" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 text-base mb-6">
              Your Comfort is Our Priority
            </p>
            <p className="text-gray-500 text-sm mb-4">
              License #CAC1815069
            </p>
            <div className="flex gap-4">
              <div className="bg-white/10 rounded-lg p-3">
                <i className="ri-shield-check-fill text-2xl text-orange-500"></i>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <i className="ri-award-fill text-2xl text-orange-500"></i>
              </div>
            </div>
          </div>

          {/* Column 2 - Services */}
          <div>
            <h3 className="text-white text-xl font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  AC Repair
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  AC Installation & Replacement
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  HVAC Maintenance
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  Duct Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  Dryer Vent Cleaning
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer hover:underline">
                  Mini Split Installation
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="text-white text-xl font-bold mb-6">Get In Touch</h3>
            <div className="space-y-4">
              <a 
                href="tel:9412233052" 
                className="flex items-center gap-3 text-orange-500 hover:text-orange-400 transition-colors cursor-pointer group"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span className="text-xl font-bold">(941) 223-3052</span>
              </a>
              <a 
                href="mailto:scdoolittle5@comcast.net" 
                className="flex items-center gap-3 text-white hover:text-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-xl"></i>
                <span>scdoolittle5@comcast.net</span>
              </a>
              <div className="flex items-start gap-3 text-gray-400">
                <i className="ri-map-pin-fill text-xl mt-1"></i>
                <span>Serving Sarasota, Venice, Nokomis, Osprey, North Port &amp; Surrounding Areas</span>
              </div>
              <div className="bg-orange-500 text-white px-4 py-2 rounded-lg inline-block font-semibold">
                Emergency Service Available
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} Doolittle Air. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
            </div>
            <div className="flex gap-3">
              <i className="ri-visa-line text-3xl text-gray-500"></i>
              <i className="ri-mastercard-line text-3xl text-gray-500"></i>
              <i className="ri-bank-card-line text-3xl text-gray-500"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}